<template>
    <div 
        class="area-tile"
        :class="isWorkshop ? 'tile-workshop' : 'tile-zone'"
        @click="enableActionButtons()"
    >
        <div class="info-container">
            <div class="name-container">
                <div
                    class="tile-icon">
                    <v-icon
                        name="square"
                    >
                    </v-icon>
                </div>
                <h2>{{ componentData.name }}</h2>
            </div>
            <div class="title-container">
                <ConsumptionPercentBadge
                    ref="consumptionPercentBadge"
                    :uid="componentData.uid"
                    entity="area"                   
                />
                <div class="tile-text">
                    <div class="meter-container">
                        <div class="meter-icon-container">
                            <img :src="energyMeterIcon(componentData.energy_meter)" alt="" class="meter-icon">
                        </div>
                        <span class="meter-name">{{ componentData.energy_meter_name }}</span>
                    </div>
                    <div
                        v-if="componentData.simulation_measure"
                        class="compute-icon"
                    >
                        <v-icon
                            name="check-circle"
                        ></v-icon>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ConsumptionPercentBadge from '@/components/partials/ui/ConsumptionPercentBadge.vue';
    export default {
        name: 'ZoneCard',
        components: {
            ConsumptionPercentBadge
        },
        props: {
            // Define any props needed for the ZoneCard component
            componentData: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                // Define any data properties needed for the WorkshopCard component
            };
        },
        computed: {
            ...mapGetters(['currentSite', 'energyMeterIcon']),
            isWorkshop() {
                return this.componentData.parent_area_uid === null;
            },
        },
        methods: {
            enableActionButtons(){
                this.$emit('enableActionButtons', this.componentData);
            },
            openZoneForm() {
                this.$store.commit('SET_CURRENT_AREA', {...this.componentData});
                this.$router.push({
                    name: 'Area',
                    params: {
                        areaType: 'zone',
                        siteUid: this.currentSite.uid,
                    }
                });
            },
            openEquipmentForm() {
                this.$router.push({
                    name: 'Equipment',
                    params: {
                        siteUid: this.currentSite.uid,
                        parentAreaUid: this.componentData.uid
                    }
                });
            },
            deleteItem(){
                this.$confirm(`Voulez-vous vraiment supprimer ${this.isWorkshop ? 'cet atelier' : 'cette zone'} ?`, this.componentData.name, {
                    type: 'warning',
                    confirmButtonText: 'Confirmer',
                    cancelButtonText: 'Annuler',
                })
                .then(() =>{
                    this.$store.dispatch('patchItem',{
                        item:{
                            archived: true,
                            url: this.componentData.url,
                            uid: this.componentData.uid
                        },
                        model: 'area',
                        url: this.$store.state.api.meta.listModels.area.url,
                    }).then(() => {
                        this.$emit('refreshTree');
                        this.$notify({
                            title: 'Success',
                            message: `${this.componentData.name} à été supprimé.`,
                            type: 'success'
                        });
                    }).catch((error) => {
                        this.$notify({
                            title: 'Error',
                            message: `Erreur lors de la suppression de ${this.componentData.name}.`,
                            type: 'error'
                        });
                    });
                })
                .catch(() => {
                    return;
                });
            },
            refreshConsumptionPercent(){
                this.$refs.consumptionPercentBadge.getConsumptionPercent();
            }
        }, 
    }
</script>

<style lang="scss">

</style>


// WEBPACK FOOTER //
// src/components/page/Synoptic/Areas/ZoneCard.vue